//User

export const LOAD_USER = "load-user";
export const LOAD_USER_FAILURE = "load-user-failure";
export const SET_SHOW_ACTIVE_USERS = "SET_SHOW_ACTIVE_USERS";

//Network Audit
export const LOAD_TWO_BY_TWO = "load-twobytwo";
export const LOAD_TWO_BY_TWO_SUCCESS = "load-twobytwo-success";
export const LOAD_TWO_BY_TWO_FAILURE = "load-twobytwo-failure";
export const EXPLORE_STORE = "explore-store";
export const EXPLORE_STORE_SUCCESS = "explore-store-success";
export const EXPLORE_STORE_FAILURE = "explore-store-failure";

//Bookmarks
export const LOAD_BOOKMARKS_SUCCESS = "load-bookmarks-success";
export const LOAD_BOOKMARKS_FAILURE = "load-bookmarks-failure";
export const SET_ACTIVE_BOOKMARK = "set-active-bookmark";
export const DELETE_BOOKMARK = "delete-bookmark";
export const DELETE_BOOKMARK_SUCCESS = "delete-bookmark-success";
export const DELETE_BOOKMARK_FAILURE = "delete-bookmark-failure";
export const SET_LOADING_BOOKMARKS = "set-loading-bookmarks";
export const SET_FOUND_BOOKMARKS = "set-found-bookmarks";
export const SET_SHOW_BOOKMARK_MODAL = "set-show-bookmark-modal";
export const SET_DEFAULT_BOOKMARK_SUCCESS = "set-default-bookmark-success";
export const SET_DEFAULT_BOOKMARK_FAILURE = "set-default-bookmark-failure";

//Sessions
export const GET_LAST_SESSION = "get-last-session";
export const SET_LOADING_LAST_SESSION = "set-loading-last-session";
export const SET_FOUND_LAST_SESSION = "set-found-last-session";
export const SET_SESSION = "set-session";
export const LOAD_LAST_SESSION = "load-last-session";

//Load SCOUT
export const LOAD_SCOUT = "load-scout";
export const SET_SCOUT_IS_SHOWING = "set-scout-is-showing";
export const SET_ACTIVE_APP = "set-active-app";
export const SET_SHOW_SPLASH_SCREEN = "set-show-splash-screen";

//My Data
export const MY_DATA_LOADED = "mydata-loaded";

export const MY_DATA_SET_BREADCRUMBS = "mydata-set-breadcrumbs";

export const RESET_MY_DATA_TYPES = "reset-mydata-types";
export const LOAD_MY_DATA_TYPES_SUCCESS = "load-mydata-types-success";
export const LOAD_MY_DATA_FAILURE = "load-mydata-failure";
export const LOAD_MY_DATA_DATA_SUCCESS = "load-mydata-data-success";
export const SET_MY_DATA_LOADING = "set-mydata-loading";
export const LOAD_MY_DATA_OTHER_SUCCESS = "load-mydata-other-success";

export const MY_DATA_LOAD_PUSHPIN_TYPES_SUCCESS
  = "mydata-load-pushpin-types-success";
export const MY_DATA_LOAD_PUSHPIN_TYPES_FAILURE
  = "mydata-load-pushpin-types-failure";
export const MY_DATA_LOAD_STORE_TYPES_SUCCESS
  = "mydata-load-store-types-success";
export const MY_DATA_LOAD_STORE_TYPES_FAILURE
  = "mydata-load-store-types-failure";
export const MY_DATA_LOAD_TERRITORY_TYPES_SUCCESS
  = "mydata-load-territory-types-success";
export const MY_DATA_LOAD_TERRITORY_TYPES_FAILURE
  = "mydata-load-territory-types-failure";
/******aoi/results types******/
export const MY_DATA_LOAD_RESULTS_POINTS_TYPES_SUCCESS
  = "mydata-load-results-points-types-success";
export const MY_DATA_LOAD_RESULTS_POINTS_TYPES_FAILURE
  = "mydata-load-results-points-types-failure";
export const MY_DATA_LOAD_RESULTS_SHAPES_TYPES_SUCCESS
  = "mydata-load-results-shapes-types-success";
export const MY_DATA_LOAD_RESULTS_SHAPES_TYPES_FAILURE
  = "mydata-load-results-shapes-types-failure";
export const MY_DATA_LOAD_AOI_POINTS_TYPES_SUCCESS
  = "mydata-load-aoi-points-types-success";
export const MY_DATA_LOAD_AOI_POINTS_TYPES_FAILURE
  = "mydata-load-aoi-points-types-failure";
export const MY_DATA_LOAD_AOI_SHAPES_TYPES_SUCCESS
  = "mydata-load-aoi-shapes-types-success";
export const MY_DATA_LOAD_AOI_SHAPES_TYPES_FAILURE
  = "mydata-load-aoi-shapes-types-failure";
export const MY_DATA_LOAD_TARGET_MARKET_LOCATIONS_SUCCESS
  = "mydata-load-target-market-locations-success";
export const MY_DATA_LOAD_TARGET_MARKET_LOCATIONS_FAILURE
  = "mydata-load-target-market-locations-failure";

export const MY_DATA_LOAD_STORE_FILE_AUDIT_SUCCESS
  = "MY_DATA_LOAD_STORE_FILE_AUDIT_SUCCESS";
export const MY_DATA_LOAD_STORE_FILE_AUDIT_FAIL
  = "MY_DATA_LOAD_STORE_FILE_AUDIT_FAIL";

export const MY_DATA_LOAD_STORE_SET_BAD_GEOCODES
  = "MY_DATA_LOAD_STORE_SET_BAD_GEOCODES";

export const MY_DATA_SET_USE_NEW_GEOCODING_SERVICE
  = "MY_DATA_SET_USE_NEW_GEOCODING_SERVICE";

export const MY_DATA_SET_MAX_FIRSTLOGIC_RECORDS
  = "MY_DATA_SET_MAX_FIRSTLOGIC_RECORDS";

  export const MY_DATA_SET_MAX_GOOGLE_RECORDS
  = "MY_DATA_SET_MAX_GOOGLE_RECORDS";

/******columns******/
export const UPDATE_MY_DATA_COLUMNS = "update-mydata-columns";
export const MY_DATA_TYPES_CHANGED = "mydata-types-changed";
/******collaborate******/
export const UPDATE_MY_DATA_TERRITORY_COLLABORATE
  = "update-mydata-territory-collaborate";
export const UPDATE_MY_DATA_PUSHPIN_COLLABORATE
  = "update-mydata-pushpin-collaborate";
/******filters******/
export const UPDATE_MY_DATA_FILTERS = "update-mydata-filters";
export const MY_DATA_REMOVE_FILTER = "mydata-remove-filter";
export const MY_DATA_REMOVE_ALL_FILTERS = "mydata-remove-all-filters";
/******sider active type******/
export const MY_DATA_SET_ACTIVE_TYPE = "mydata-set-active-type";

export const MY_DATA_SET_CURRENT_PAGE = "mydata-set-current-page";
export const MY_DATA_SET_PAGE_SIZE = "mydata-set-page-size";
/******sort******/
export const UPDATE_SORT_DIRECTION = "update-sort-direction";
export const RESET_SORT_DIRECTION = "reset-sort-direction";
/******set cloud folder******/
export const MY_DATA_SET_CURRENT_CLOUD_FOLDER
  = "mydata-set-current-cloud-folder";
export const MY_DATA_BUILD_CURRENT_CLOUD_TYPE_DICT
  = "mydata-build-current-cloud-type-dict";
/******delete cloud folder******/
export const MY_DATA_RESET_DELETE_CLOUD_FOLDER_MESSAGE
  = "mydata-reset-delete-cloud-folder-message";
export const MY_DATA_DELETE_CLOUD_FOLDER_LOADING
  = "mydata-delete-cloud-folder-loading";
export const MY_DATA_DELETE_CLOUD_FOLDER_SUCCESS
  = "mydata-delete-cloud-folder-success";
export const MY_DATA_DELETE_CLOUD_FOLDER_FAILURE
  = "mydata-delete-cloud-folder-failure";
/******load aoi/results types******/
export const LOAD_MY_DATA_CLOUD_TYPES_SUCCESS
  = "load-mydata-cloud-types-success";
export const LOAD_MY_DATA_CLOUD_TYPES_FAILURE
  = "load-mydata-cloud-types-failure";
export const LOAD_FROM_SCOUT_MY_DATA_AOI_POINT_TYPES_SUCCESS
  = "load-from-scout-mydata-aoi-point-types-success";
export const LOAD_FROM_SCOUT_MY_DATA_AOI_SHAPE_TYPES_SUCCESS
  = "load-from-scout-mydata-aoi-shape-types-success";
export const LOAD_FROM_SCOUT_MY_DATA_RESULT_POINT_TYPES_SUCCESS
  = "load-from-scout-mydata-result-point-types-success";
export const LOAD_FROM_SCOUT_MY_DATA_RESULT_SHAPE_TYPES_SUCCESS
  = "load-from-scout-mydata-result-shape-types-success";
/******add cloud folder******/
export const MY_DATA_RESET_ADD_CLOUD_FOLDER_MESSAGE
  = "mydata-reset-add-cloud-folder-message";
export const MY_DATA_ADD_CLOUD_FOLDER_LOADING
  = "mydata-add-cloud-folder-loading";
export const MY_DATA_ADD_CLOUD_FOLDER_SUCCESS
  = "mydata-add-cloud-folder-success";
export const MY_DATA_ADD_CLOUD_FOLDER_FAILURE
  = "mydata-add-cloud-folder-failure";
/******update cloud file******/
export const MY_DATA_RESET_UPDATE_CLOUD_FILE_MESSAGE
  = "mydata-reset-update-cloud-file-message";
export const MY_DATA_UPDATE_CLOUD_FILE_LOADING
  = "mydata-update-cloud-file-loading";
export const MY_DATA_UPDATE_CLOUD_FILE_SUCCESS
  = "mydata-update-cloud-file-success";
export const MY_DATA_UPDATE_CLOUD_FILE_FAILURE
  = "mydata-update-cloud-file-failure";
/******delete cloud file******/
export const MY_DATA_RESET_DELETE_CLOUD_FILE_MESSAGE
  = "mydata-reset-delete-cloud-file-message";
export const MY_DATA_DELETE_CLOUD_FILE_LOADING
  = "mydata-delete-cloud-file-loading";
export const MY_DATA_AOI_POINTS_DELETE_CLOUD_FILE_SUCCESS
  = "mydata-aoi-points-delete-cloud-file-success";
export const MY_DATA_AOI_SHAPES_DELETE_CLOUD_FILE_SUCCESS
  = "mydata-aoi-shapes-delete-cloud-file-success";
export const MY_DATA_RESULTS_POINTS_DELETE_CLOUD_FILE_SUCCESS
  = "mydata-results-points-delete-cloud-file-success";
export const MY_DATA_RESULTS_SHAPES_DELETE_CLOUD_FILE_SUCCESS
  = "mydata-results-shapes-delete-cloud-file-success";
export const MY_DATA_DELETE_CLOUD_FILE_FAILURE
  = "mydata-delete-cloud-file-failure";

// User Preferences
export const GET_USER_PREFERENCES_SUCCESS = "get-user-preferences-success";
export const GET_USER_PREFERENCES_SUCCESS_SCOUT = "GET_USER_PREFERENCES_SUCCESS_SCOUT";
export const GET_USER_PREFERENCES_FAILURE = "get-user-preferences-failure";
export const UPDATE_USER_PREFERENCES_SUCCESS
  = "update-user-preferences-success";
export const UPDATE_USER_PREFERENCES_FAILURE
  = "update-user-preferences-failure";
export const GET_ALL_COMMUNITY_SITES_SUCCESS
  = "get-all-community-sites-success";
export const GET_ALL_COMMUNITY_SITES_FAILURE
  = "get-all-community-sites-failure";

// User Management
export const GET_USER_FRANCHISEE_STORE_INFORMATION_SUCCESS
  = "get-user-franchisee-store-information-success";
export const GET_USER_FRANCHISEE_STORE_INFORMATION_FAILURE
  = "get-user-franchisee-store-information-failure";
export const GET_USER_FRANCHISEE_TERRITORY_INFORMATION_SUCCESS
  = "get-user-franchisee-territory-information-success";
export const GET_USER_FRANCHISEE_TERRITORY_INFORMATION_FAILURE
  = "get-user-franchisee-territory-information-failure";
export const REMOVE_STORE_FROM_FRANCHISEE_USER_SUCCESS
  = "remove-store-from-franchisee-user-success";
export const REMOVE_STORE_FROM_FRANCHISEE_USER_FAILURE
  = "remove-store-from-franchisee-user-failure";
export const REMOVE_TERRITORY_FROM_FRANCHISEE_USER_SUCCESS
  = "remove-territory-from-franchisee-user-success";
export const REMOVE_TERRITORY_FROM_FRANCHISEE_USER_FAILURE
  = "remove-territory-from-franchisee-user-failure";
export const USER_UPDATE_ACTIVE_STATUS_SUCCESS
  = "user-update-active-status-success";
export const USER_UPDATE_ACTIVE_STATUS_FAILURE
  = "user-update-active-status-failure";
export const UPDATE_TERRITORY_TYPE_ADMIN_ONLY_SUCCESS
  = "update-territory-type-admin-only-success";
export const UPDATE_TERRITORY_TYPE_ADMIN_ONLY_FAILURE
  = "update-territory-type-admin-only-failure";
export const GET_TERRITORY_TYPE_PERMISSIONS_SUCCESS
  = "get-territory-type-user-permissions-success";
export const GET_TERRITORY_TYPE_PERMISSIONS_FAILURE
  = "get-territory-type-user-permissions-failure";
export const UPDATE_TERRITORY_TYPE_USER_PERMISSIONS_SUCCESS
  = "update-territory-type-user-permissions-success";
export const UPDATE_TERRITORY_TYPE_USER_PERMISSIONS_FAILURE
  = "update-territory-type-user-permissions-failure";
export const UPDATE_TERRITORY_TYPE_USER_PERMISSIONS_FOR_ALL_SUCCESS
  = "update-territory-type-user-permissions-for-all-success";
export const UPDATE_TERRITORY_TYPE_USER_PERMISSIONS_FOR_ALL_FAILURE
  = "update-territory-type-user-permissions-for-all-failure";
export const GET_TERRITORY_TYPES_SUCCESS = "get-territory-types-success";
export const GET_TERRITORY_TYPES_FAILURE = "get-territory-types-failure";
export const LAUNCH_USER_MANAGEMENT_FROM_SCOUT
  = "launch-user-management-from-scout";
export const LAUNCH_TERRITORY_MANAGEMENT_FROM_SCOUT
  = "launch-territory-management-from-scout";

// User Profile
export const UPDATE_SAVE_PROFILE_LOADING = "update-save-profile-loading";
export const UPDATE_USER_PROFILE_SUCCESS = "update-user-profile-success";
export const UPDATE_USER_PROFILE_FAILURE = "update-user-profile-failure";
export const UPDATE_SHARE_IMAGE_SUCCESS = "UPDATE_SHARE_IMAGE_SUCCESS";
export const UPDATE_SHARE_IMAGE_FAILURE = "UPDATE_SHARE_IMAGE_FAILURE";
export const UPDATE_USER_SHARE_SETTINGS_SUCCESS
  = "update-user-share-settings-success";
export const GET_USER_SHARE_SETTINGS_SUCCESS
  = "get-user-share-settings-success";
export const GET_USER_SHARE_SETTINGS_FAILURE
  = "get-user-share-settings-failure";
export const RESET_PASSWORD_SUCCESS = "reset-password-success";
export const RESET_PASSWORD_FAILURE = "reset-password-failure";
export const UPDATE_USER_AVATAR_SUCCESS = "update-user-avatar-success";
export const UPDATE_USER_AVATAR_FAILURE = "update-user-avatar-failure";
export const DELETE_USER_AVATAR_SUCCESS = "delete-user-avatar-success";
export const DELETE_USER_AVATAR_FAILURE = "delete-user-avatar-failure";
export const DELETE_SHARE_IMAGE_SUCCESS = "DELETE_SHARE_IMAGE_SUCCESS";
export const DELETE_SHARE_IMAGE_FAILURE = "DELETE_SHARE_IMAGE_FAILURE";
export const USER_PROFILE_SET_MFA_FACTORS = "user-profile-set-mfa-factors";
export const USER_PROFILE_SET_SELECTED_MFA_FACTOR_ID
  = "user-profile-set-selected-mfa-factor-id";
export const USER_PROFILE_SET_WAITING_FOR_MFA_RESPONSE
  = "user-profile-set-waiting-for-mfa-response";
export const USER_PROFILE_SET_MFA_RESULT = "user-profile-set-mfa-result";
export const USER_PROFILE_SET_SHOW_MFA_ENROLLMENT_MODAL
  = "user-profile-set-show-mfa-enrollment-modal";
export const USER_PROFILE_SET_MFA_ENROLLMENT_MODAL_TEXT
  = "user-profile-set-mfa-enrollment-modal-text";
export const USER_PROFILE_SET_MFA_ENROLLMENT_UPDATED_THIS_SESSION
  = "user-profile-set-mfa-enrollment-updated-this-session";

// Account Team
export const GET_COMPANY_SUPPORT_TEAM_SUCCESS
  = "get-company-support-team-success";
export const GET_COMPANY_SUPPORT_TEAM_FAILURE
  = "get-company-support-team-failure";

// Timeout Management
export const UPDATE_SESSION_TIMEOUT_LENGTH_SUCCESS
  = "update-session-timeout-length-success";
export const UPDATE_SESSION_TIMEOUT_LENGTH_FAILURE
  = "update-session-timeout-length-failure";

//Reports
export const SET_REPORTS = "set-reports";
export const SET_LOADING_REPORTS = "set-loading-reports";
export const SET_FOUND_REPORTS = "set-found-reports";
export const SET_REPORTS_COLLABORATING = "set-reports-collaborating";
export const SET_SELECTED_REPORT_ID = "set-selected-report-id";
export const SET_SHOW_RECENT_REPORTS_MODAL = "set-show-recent-reports-modal";
export const DOWNLOAD_REPORT_FILE = "download-report-file";
export const SET_REPORT_FILE = "set-report-file";
export const SET_SELECTED_REPORT_FILES = "set-selected-report-files";
export const SET_SELECTED_REPORT_FILE = "set-selected-report-file";
export const SET_SHOW_REPORT_FILE_MODAL = "set-show-report-file-modal";
export const DELETE_REPORT = "delete-report";
export const DELETE_REPORT_SUCCESS = "delete-report-success";
export const SET_REPORTS_DATES = "set-reports-dates";
export const REPORT_FINISHED = "report-finished";
export const RESET_REPORT_COUNTER = "reset-report-counter";
export const SET_INSIGHTS_COLLABORATING = "SET_INSIGHTS_COLLABORATING";
export const PROCESS_JOBS_SUCCESS = "PROCESS_JOBS_SUCCESS";
export const GET_CONFIG_REPORTS_SUCCESS = "GET_CONFIG_REPORTS_SUCCESS";
export const SET_LOADING_CONFIG_REPORTS = "SET_LOADING_CONFIG_REPORTS";
export const SET_CR_MODAL_VISIBILITY = "SET_SHOW_CR_MODAL_VISIBILITY";
export const SET_CR_SELECTED_ITEMS = "SET_CR_SELECTED_ITEMS";
export const DELETE_CONFIG_REPORT_SUCCESS = "DELETE_CONFIG_REPORT_SUCCESS";
export const ADD_RUNNING_CONFIG_REPORT_TO_LIST = "ADD_RUNNING_CONFIG_REPORT_TO_LIST";

// Sales Performance
export const SALES_PERFORMANCE_SET_DATA = "sales-performance-set-data";
export const SALES_PERFORMANCE_SET_LOADING = "sales-performance-set-loading";

// GPS Insights
export const SET_GPS_INSIGHT_RESULTS = "set-gps-insight-results";
export const UPDATE_GPS_INSIGHT_JOB = "update-gps-insight-job";
export const RESET_GPS_INSIGHT_RESULTS = "reset-gps-insight-results";

export const SET_LOADING_BRAND = "SET_LOADING_BRAND";
export const GET_BRAND_SUCCESS = "GET_BRAND_SUCCESS";

export const SET_LOADING_JOBS = "SET_LOADING_JOBS";
export const GET_JOBS_SUCCESS = "GET_JOBS_SUCCESS";

export const SET_LOADING_SINGLE_JOB = "SET_LOADING_SINGLE_JOB";
export const GET_SINGLE_JOB_SUCCESS = "GET_SINGLE_JOB_SUCCESS";

export const SET_LOADING_GPS_MOBILE_INSIGHTS_REPORT
  = "SET_LOADING_GPS_MOBILE_INSIGHTS_REPORT";

export const ADD_RUNNING_INSIGHT_TO_LIST = "ADD_RUNNING_INSIGHT_TO_LIST";
export const ADD_FINISHED_INSIGHT_TO_LIST = "ADD_FINISHED_INSIGHT_TO_LIST";
export const REMOVE_FINISHED_INSIGHT_FROM_RUNNING_INSIGHTS
  = "REMOVE_FINISHED_INSIGHTS_FROM_RUNNING_INSIGHT";
export const CLEAR_RUNNING_AND_FINISHED_INSIGHTS_LISTS
  = "CLEAR_RUNNING_AND_FINISHED_INSIGHTS_LISTS";
export const CLEAR_FINISHED_INSIGHTS_LISTS = "CLEAR_FINISHED_INSIGHTS_LISTS";
export const SELECT_GPS_INSIGHT_FOR_REPORT_VIEW
  = "SELECT_GPS_INSIGHT_FOR_REPORT_VIEW";
export const SET_CURRENT_GPS_INSIGHT_VIEW = "SET_CURRENT_GPS_INSIGHT_VIEW";
export const SET_GPS_INSIGHT_MODAL_VISIBLE = "SET_GPS_INSIGHT_MODAL_VISIBLE";
export const START_GPS_MOBILE_INSIGHTS_REPORT
  = "START_GPS_MOBILE_INSIGHTS_REPORT";

export const SET_LOADING_SAVE_TO_SCOUT = "SET_LOADING_SAVE_TO_SCOUT";
export const SET_POLYGON_CENTROID = "SET_POLYGON_CENTROID";

export const SAVE_TO_SCOUT_SUCCESS = "SAVE_TO_SCOUT_SUCCESS";

export const SET_MOBILYTICS_SCENARIOS = "SET_MOBILYTICS_SCENARIOS";

export const SET_FVP_MARKERS = "SET_FVP_MARKERS";
export const SET_SELECTED_FVP = "SET_SELECTED_FVP";

// Retail Match
export const GET_RETAIL_MATCH_RESULTS_SUCCESS
  = "GET_RETAIL_MATCH_RESULTS_SUCCESS";
export const GET_RETAIL_MATCH_RESULTS_FAILURE
  = "GET_RETAIL_MATCH_RESULTS_FAILURE";
export const SET_RETAIL_MATCH_BENCHMARK_RECORD
  = "SET_RETAIL_MATCH_BENCHMARK_RECORD";
export const SET_LOADING_RETAIL_MATCH_GEOGRAPHIES
  = "SET_LOADING_RETAIL_MATCH_GEOGRAPHIES";
export const GET_RETAIL_MATCH_GEOGRAPHIES_SUCCESS
  = "GET_RETAIL_MATCH_GEOGRAPHIES_SUCCESS";
export const GET_RETAIL_MATCH_GEOGRAPHIES_FAILURE
  = "GET_RETAIL_MATCH_GEOGRAPHIES_FAILURE";
export const GET_RETAIL_MATCH_BRAND_SUCCESS = "GET_RETAIL_MATCH_BRAND_SUCCESS";
export const GET_RETAIL_MATCH_BRAND_FAILURE = "GET_RETAIL_MATCH_BRAND_FAILURE";
export const GET_RETAIL_MATCH_BRANDS_SUCCESS
  = "GET_RETAIL_MATCH_BRANDS_SUCCESS";
export const GET_RETAIL_MATCH_BRANDS_FAILURE
  = "GET_RETAIL_MATCH_BRANDS_FAILURE";
export const SET_LOADING_BRANDS = "SET_LOADING_BRANDS";
export const GET_RETAIL_MATCH_CATEGORIES_SUCCESS
  = "GET_RETAIL_MATCH_CATEGORIES_SUCCESS";
export const GET_RETAIL_MATCH_CATEGORIES_FAILURE
  = "GET_RETAIL_MATCH_CATEGORIES_FAILURE";
export const SET_LOADING_CATEGORIES = "SET_LOADING_CATEGORIES";
export const SET_RETAIL_MATCH_REPORT_MODAL_VISIBLE
  = "SET_RETAIL_MATCH_REPORT_MODAL_VISIBLE";
export const START_RETAIL_MATCH_REPORT = "START_RETAIL_MATCH_REPORT";
export const SET_LOADING_RETAIL_MATCH_REPORT
  = "SET_LOADING_RETAIL_MATCH_REPORT";
export const SUBMIT_RETAIL_MATCH_REPORT_SUCCESS
  = "SUBMIT_RETAIL_MATCH_REPORT_SUCCESS";
export const SUBMIT_RETAIL_MATCH_REPORT_FAILURE
  = "SUBMIT_RETAIL_MATCH_REPORT_FAILURE";
export const UPDATE_RETAIL_MATCH_JOB_SUCCESS
  = "UPDATE_RETAIL_MATCH_JOB_SUCCESS";
export const UPDATE_RETAIL_MATCH_JOB_FAILURE
  = "UPDATE_RETAIL_MATCH_JOB_FAILURE";
export const ADD_RETAIL_MATCH_IMAGE_SUCCESS = "ADD_RETAIL_MATCH_IMAGE_SUCCESS";
export const ADD_RETAIL_MATCH_IMAGE_FAILURE = "ADD_RETAIL_MATCH_IMAGE_FAILURE";
export const UPDATE_BRAND_LOGO_SUCCESS = "UPDATE_BRAND_LOGO_SUCCESS";
export const SET_LOADING_UPDATE_RETAIL_MATCH_JOB
  = "SET_LOADING_UPDATE_RETAIL_MATCH_JOB";
export const CLEAR_RETAIL_MATCH_RESULTS = "CLEAR_RETAIL_MATCH_RESULTS";
export const SET_LOADING_BRANDS_SAMPLE_SET_DATA
  = "SET_LOADING_BRANDS_SAMPLE_SET_DATA";
export const GET_BRANDS_SAMPLE_SET_DATA_SUCCESS
  = "GET_BRANDS_SAMPLE_SET_DATA_SUCCESS";
export const SET_SELECTED_BRAND = "SET_SELECTED_BRAND";
export const SET_RETAIL_MATCH_OVERVIEW_MAP_MARKERS
  = "SET_RETAIL_MATCH_OVERVIEW_MAP_MARKERS";
export const SET_RETAIL_MATCH_MODAL_MARKER_CLUSTERER
  = "SET_RETAIL_MATCH_MODAL_MARKER_CLUSTERER";
export const UPDATE_RETAIL_MATCH_SITE_DETAILS_SUCCESS = "UPDATE_RETAIL_MATCH_SITE_DETAILS_SUCCESS";

export const GET_MOSAIC_SEGMENTS_SUCCESS = "GET_MOSAIC_SEGMENTS_SUCCESS";
export const SET_LOADING_MOSAIC_SEGMENTS = "SET_LOADING_MOSAIC_SEGMENTS";

//map
export const CREATE_NEW_GOOGLE_MAP = "CREATE_NEW_GOOGLE_MAP";
export const CREATE_NEW_RETAIL_MATCH_OVERVIEW_MAP
  = "CREATE_NEW_RETAIL_MATCH_OVERVIEW_MAP";
export const CREATE_NEW_RETAIL_MATCH_MODAL_MAP
  = "CREATE_NEW_RETAIL_MATCH_MODAL_MAP";
export const CLEAR_CURRENT_GOOGLE_MAP_REF = "CLEAR_CURRENT_GOOGLE_MAP_REF";
export const SET_MAP_CENTER = "SET_MAP_CENTER";
export const SET_PENDING_MAP_CENTER_EVENT = "SET_PENDING_MAP_CENTER_EVENT";
export const SET_MAP_ZOOM = "SET_MAP_ZOOM";
export const SET_MAP_MARKERS = "SET_MAP_MARKERS";
export const SET_MAP_STYLES = "SET_MAP_STYLES";
export const SET_MAP_STYLE_OPTIONS = "SET_MAP_STYLE_OPTIONS";
export const SET_MAP_ANCHOR_WINDOW = "SET_MAP_ANCHOR_WINDOW";
export const GET_STORE_TRADE_AREA_BLOCK_GROUP_POLYGONS
  = "GET_STORE_TRADE_AREA_BLOCK_GROUP_POLYGONS";
export const SET_MAP_LOADING = "SET_MAP_LOADING";
export const SET_MAP_IS_READY = "SET_MAP_IS_READY";
export const CLEAR_GOOGLE_MAP = "CLEAR_GOOGLE_MAP";
export const SET_MAP_HEIGHT = "SET_MAP_HEIGHT";

//leftnav
export const SHOW_LEFT_NAV = "SHOW_LEFT_NAV";
export const HIDE_LEFT_NAV = "HIDE_LEFT_NAV";
export const TOGGLE_LEFT_NAV = "TOGGLE_LEFT_NAV";
export const UPDATE_MOBILYTICS_VISITORS_GROUPS
  = "UPDATE_MOBILYTICS_VISITORS_GROUPS";
export const TOGGLE_MAP_LAYER_MOBILYTICS_VISITORS_ACTUALS
  = "TOGGLE_MAP_LAYER_MOBILYTICS_VISITORS_ACTUALS";
export const SET_LOADING_PLACES = "SET_LOADING_PLACES";

//Toolbox

export const SHOW_MAP_SETTINGS_MODAL = "SHOW_MAP_SETTINGS_MODAL";

//Digital Share
export const SET_DIGITAL_SHARE_DIALOG_TRAINING_STATE
  = "SET_DIGITAL_SHARE_DIALOG_TRAINING_STATE";
export const OPEN_DIGITAL_SHARE_DIALOGUE_FROM_WRAPPER
  = "OPEN_DIGITAL_SHARE_DIALOGUE_FROM_WRAPPER";

// Factor
export const START_FACTOR_REPORT = "START_FACTOR_REPORT";
export const SET_FACTOR_SCENARIOS = "SET_FACTOR_SCENARIOS";
export const SET_FACTOR_VISIBLE = "SET_FACTOR_VISIBLE";
export const SET_FACTOR_LOADING_SCENARIOS = "SET_FACTOR_LOADING_SCENARIOS";

// PDF Print
export const GET_PDF_LAMBDA = 'GET_PDF_LAMBDA';

// Notification Workflow
export const SET_NOTIFICATION_WORKFLOW_URL = "SET_NOTIFICATION_WORKFLOW_URL";

